import { render, staticRenderFns } from "./CustomizeMetalB.vue?vue&type=template&id=f3f4465c&scoped=true"
import script from "./CustomizeMetalB.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalB.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalB.vue?vue&type=style&index=0&id=f3f4465c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f4465c",
  null
  
)

export default component.exports